import React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import StockChart from "../company/TradingViewChart";
import "../css/home.css";

const ChartsContainer = styled(Paper)(({ theme }) => ({
  padding: 0,
  margin: 0,
  borderRadius: "16px",
  overflow: "hidden",
  background: "linear-gradient(180deg, #ffffff 0%, #fafbfc 100%)",
  border: "1px solid rgba(16, 33, 56, 0.06)",
  boxShadow: "0 4px 20px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.02)",
}));

const ChartCard = styled(Box)(({ theme }) => ({
  padding: "1.25rem",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  background: "#ffffff",
  border: "1px solid rgba(16, 33, 56, 0.06)",
  boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    boxShadow: "0 6px 20px rgba(16, 33, 56, 0.08)",
    borderColor: "rgba(212, 160, 23, 0.2)",
  },
  [theme.breakpoints.down("md")]: {
    padding: "1rem",
  },
}));

const ChartHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginBottom: "1rem",
  paddingBottom: "0.75rem",
  borderBottom: "1px solid rgba(16, 33, 56, 0.06)",
});

const IndexLabel = styled(Typography)({
  fontWeight: 700,
  fontSize: "1rem",
  color: "#102138",
  letterSpacing: "-0.01em",
});

const IndexSymbol = styled(Typography)({
  fontSize: "0.8rem",
  color: "#5a6c7d",
  fontWeight: 500,
});

const indexConfig = [
  { symbol: "DJI", name: "Dow Jones", sub: "Industrial Average" },
  { symbol: "FOREXCOM:SPX500", name: "S&P 500", sub: "Large Cap" },
  { symbol: "FOREXCOM:NAS100", name: "Nasdaq 100", sub: "US 100 Cash CFD" },
];

export default function IndexCharts() {
  return (
    <ChartsContainer elevation={0}>
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} sx={{ p: { xs: 1.5, sm: 2 } }}>
        {indexConfig.map(({ symbol, name, sub }) => (
          <Grid item xs={12} md={4} key={symbol}>
            <ChartCard>
              <ChartHeader>
                <Box
                  sx={{
                    width: 6,
                    height: 24,
                    borderRadius: 1,
                    background: "linear-gradient(180deg, #d4a017 0%, #e8c547 100%)",
                  }}
                />
                <Box>
                  <IndexLabel>{name}</IndexLabel>
                  <IndexSymbol>{sub}</IndexSymbol>
                </Box>
              </ChartHeader>
              <Box sx={{ flex: 1, minHeight: 280 }}>
                <StockChart symbol={symbol} />
              </Box>
            </ChartCard>
          </Grid>
        ))}
      </Grid>
    </ChartsContainer>
  );
}
